import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { select, Store } from '@ngrx/store';
import {CampaignService} from '../../../campaign/services/campaign.service';
import {DialogService} from '../../../dialog/services/dialog.service';
import * as DialogActions from '../../../dialog/features/dialog.actions';
import {moveItemInArray} from '@angular/cdk/drag-drop';
import { RegistrationSchema} from '../../../campaign/structure/event-page';
import { takeUntil } from 'rxjs/operators';
import { selectEventConfig } from '../../features/event.selectors';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-registration-list',
  templateUrl: './registration-list.component.html',
  styleUrls: ['./registration-list.component.scss']
})
export class RegistrationListComponent implements OnInit {
  @Input() form: UntypedFormGroup = null;
  @Input() registrations: any = null;
  @Input() eventPageId: string;
  @Output() onDrop = new EventEmitter<any>();

  public button: UntypedFormGroup = null;
  public buttons: UntypedFormArray = null;
  public eventConfigData: any = null;
  public eventInfo: any;

  constructor(
    public store: Store,
    public formBuilder: UntypedFormBuilder,
    public campaignService: CampaignService,
    public dialogService: DialogService,
  ) {
    this.button = this.formBuilder.group({});
    this.campaignService.generateForm(this.button, RegistrationSchema);
  }

  private takeUntilSubject: Subject<any> = new Subject();
  public loadEventConfig$ = this.store.pipe(
    select(selectEventConfig)
  );

  ngOnInit(){
    this.loadEventConfig$
    .pipe(takeUntil(this.takeUntilSubject))
    .subscribe((eventConfig) => {
      this.eventConfigData = eventConfig;
    });
  }

  addRegistrationButton(initialState = {id: null, action: 'add'}) {
    const action = DialogActions.openDialog({
      payload: {
        name: 'registrationButtonForm',
        options: {
          size: 'default',
          modalClass:'modal--paybee',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState
      }
    });
    this.store.dispatch(action);
  }

  dropOption(event) {
    moveItemInArray(this.eventConfigData.registrations, event.previousIndex, event.currentIndex);
    this.onDrop.emit(true);
  }

  identify(index, item){
    return item.name;
  }
}
